export const downloadFile = async ({
  resource,
  filename,
  // type = 'text/plain',
  openInNewTab = false,
}: {
  resource: Blob | string;
  filename: string;
  type?: string;
  openInNewTab?: boolean;
}) => {
  const file = typeof resource === 'string' ? await fetch(resource).then((r) => r.blob()) : resource;
  // IE10+
  if (
    'msSaveOrOpenBlob' in window.navigator &&
    window.navigator['msSaveOrOpenBlob'] &&
    typeof window.navigator['msSaveOrOpenBlob'] === 'function'
  ) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.navigator.msSaveOrOpenBlob(file, filename);
  } else {
    // Others
    const a = document.createElement('a'),
      url = URL.createObjectURL(file);
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);
    if (openInNewTab) {
      window.open(url);
    }
  }
};
